import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'shop_brands',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    brandList: function brandList() {
      var _this$value$config$br;
      return ((_this$value$config$br = this.value.config.brandList) === null || _this$value$config$br === void 0 ? void 0 : _this$value$config$br.slice(0, 8)) || [];
    }
  }
};